/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css } from '@emotion/react';
import { N90, N800, N0 } from '@atlaskit/theme/colors';
export var verticalMargin = 5;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var tooltipStyle = css({
  maxWidth: '150px',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  marginBottom: verticalMargin,
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
  ul: {
    listStyle: 'none',
    margin: 0,
    padding: 0,
    textAlign: 'left'
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
  li: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    marginTop: verticalMargin
  }
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var emojiNameStyle = css({
  textTransform: 'capitalize',
  color: "var(--ds-text-inverse, ".concat(N90, ")"),
  fontWeight: 600
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var footerStyle = css({
  color: "var(--ds-text-inverse, ".concat(N90, ")"),
  fontWeight: 300
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var underlineStyle = css({
  cursor: 'pointer',
  textDecoration: 'underline',
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
  ':hover': {
    backgroundColor: "var(--ds-background-neutral-bold, ".concat(N800, ")"),
    color: "var(--ds-text-inverse, ".concat(N0, ")")
  }
});